import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { BalanceTypeEnum } from "helpers/types";

interface BalanceTypeToggleProps {
  value: BalanceTypeEnum;
  onChange: (value: BalanceTypeEnum) => void;
}

const OPTIONS: { value: BalanceTypeEnum; label: string }[] = [
  { value: BalanceTypeEnum.TRADE_AMOUNT, label: "Trade Amount" },
  { value: BalanceTypeEnum.PORTFOLIO, label: "Portfolio" },
];

const BalanceTypeToggle = ({ value, onChange }: BalanceTypeToggleProps) => (
  <ToggleButtonGroup
    size="small"
    exclusive
    value={value}
    onChange={(_, next) => next && onChange(next)}
  >
    {OPTIONS.map(({ value: optionValue, label }) => (
      <ToggleButton key={optionValue} value={optionValue}>
        {label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);

export default BalanceTypeToggle;
